import React, {useContext} from 'react';
import {Context} from "../ApiClient";
import Document from "./Document";
import Filters from "./Filters";

export default function DocumentList() {

    // Getting object containing events from context, so we need to use braces
    const {documents}                          = useContext(Context);
    let [filteredDocuments, setFilteredDocuments] = React.useState([])

    function CallbackActiveFilters(filters) {
        filterDocuments(documents, filters);
    }

    function filterDocuments(documents, filters) {

        // ignore if documents is not an array
        if (!Array.isArray(documents)) {
            return 1;
        }

        let filteredDocuments = documents.filter((document) => {
            // Manipulate arrays to compare them
            let documentThemes      = document.themes.split(', ');
            let filterThemes      = filters.activeThemes.map(filterThemes => filterThemes.value);

            // If document is longer than one month and the filter date is in the middle of the document
            // If monthMode is false, then we compare years only
            // If monthMode is true, then we compare years and months

            const filteredThemes      = documentThemes.filter(value => filterThemes.includes(value));

            // If filter is empty, then we return true, else we return true if the document contains the filter and the date is correct
            return (!filterThemes.length || filteredThemes.length)
        });


        let searchValues  = filters.searchValue.split(' ');
        searchValues      = searchValues.filter(word => word.length > 2);

        // Recherche d'un des mots clés de la barre de recherche dans le titre du document
        if (searchValues.length !== 0) {
            filteredDocuments = filteredDocuments.filter(document =>
                searchValues.some(searchValue => document.title.toUpperCase().includes(searchValue.toUpperCase())));
        }

        setFilteredDocuments(filteredDocuments);
    }

    return (
        // if documents is not empty, then render the event list
        <div className="container">
            <Filters handleCallback={CallbackActiveFilters}/>
            {
                filteredDocuments && filteredDocuments.map((document) => (
                    <Document document={document} key={document.title}/>
                ))
            }
            {
                !filteredDocuments?.length ? <div className="no-content">
                <div>Aucun document à afficher</div>
                </div> : null
            }
        </div>
    )
}